import { TokenMetadataSource } from "../graphql/generated/stats2.sdk";
export const ADA_METADATA = {
    assetId: "",
    policyId: "",
    assetName: null,
    decimals: 6,
    logo: null,
    ticker: "ADA",
    dateListed: "2022-08-04 20:03:25.900564817 +0000 UTC m=+2803.339090301",
    sources: [],
};
export const SUNDAE_METADATA = {
    assetId: "9a9693a9a37912a5097918f97918d15240c92ab729a0b7c4aa144d77.53554e444145",
    policyId: "9a9693a9a37912a5097918f97918d15240c92ab729a0b7c4aa144d77",
    assetName: "SUNDAE",
    decimals: 6,
    logo: "https://d34fnwb617749y.cloudfront.net/logos/983/9830390119461449821.png",
    ticker: "SUNDAE",
    dateListed: "2022-08-04 19:53:52.355770709 +0000 UTC",
    sources: [TokenMetadataSource.CardanoTokenRegistry, TokenMetadataSource.OnChainLabel20],
};
//# sourceMappingURL=cardano.js.map